/**
 * Reusable AVX Pro brand logo.
 * Variants:
 *  - "full" (default): Logo image + wordmark in header style
 *  - "image": Just the logo image (square)
 *  - "wordmark": Pure typography (no image)
 */
import { Link } from "react-router-dom";

export default function Logo({ variant = "full", to = "/", className = "", size = "md", testId }) {
    const sizes = {
        sm: { img: "h-7 w-auto", title: "text-sm", sub: "text-[8px]" },
        md: { img: "h-9 w-auto", title: "text-base", sub: "text-[9px]" },
        lg: { img: "h-12 w-auto", title: "text-xl", sub: "text-[10px]" },
    };
    const s = sizes[size] || sizes.md;

    const inner = (
        <>
            {variant !== "wordmark" && (
                <img
                    src="/avx-pro-logo.png"
                    alt="AVX Pro"
                    className={`${s.img} object-contain shrink-0`}
                />
            )}
            {variant !== "image" && (
                <div className="leading-none">
                    <div className={`font-heading font-black tracking-tight ${s.title}`}>
                        <span className="brand-text">AV</span>
                        <span className="brand-text-x">X</span>
                    </div>
                    <div className={`label-mono ${s.sub}`}>Pro</div>
                </div>
            )}
        </>
    );

    const baseCls = `inline-flex items-center gap-3 ${className}`;

    if (to) {
        return (
            <Link to={to} className={baseCls} data-testid={testId}>
                {inner}
            </Link>
        );
    }
    return <div className={baseCls} data-testid={testId}>{inner}</div>;
}
